module.exports = __webpack_public_path__ + "static/img/6ac3de9cc84af1aca182669590168999.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/advant_active_02.png
// module id = C+mM
// module chunks = 1